<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M23.4 1.7l.4.4c.1.2.2.4.2.5v.6c0 .2-.1.3-.2.5L9.6 22c-.1.2-.3.3-.5.4-.2.1-.4.2-.6.2-.2 0-.4 0-.6-.1-.2-.1-.4-.2-.5-.3L.3 15.1c-.3-.3-.4-.6-.4-1s.2-.7.4-1 .6-.4 1-.4.7.1 1 .4l6 5.9L21.5 2l.4-.4c.2-.1.3-.2.5-.2h.6c.1.1.3.2.4.3z"
    />
  </svg>
</template>
